import type { FC } from 'react';
import ShoppingBasket from '@mui/icons-material/ShoppingBasket';
import { Box, Stack } from '@mui/material';

import { MAX_REPORTS_IN_SHOPPING_CART } from 'src/constants/report';
import { useShoppingCart } from 'src/components/report/ShoppingCartContext';

import { styles } from './index.styles';

export const SHOPPING_CART_TEST_ID = 'shopping-cart';
export const SHOPPING_CART_BASKET_ICON_TEST_ID = 'shopping-cart-basket-icon';

const ShoppingCart: FC = () => {
  const { shoppingCartItems } = useShoppingCart();

  return (
    <Stack
      direction="row"
      sx={styles.shoppingCart}
      data-test-id={SHOPPING_CART_TEST_ID}
    >
      <Stack
        direction="row"
        sx={{ justifyContent: 'center', ...styles.counterWrapper }}
      >
        <Box sx={styles.counter}>
          {`${shoppingCartItems.length} / ${MAX_REPORTS_IN_SHOPPING_CART}`}
        </Box>
      </Stack>
      <Stack
        direction="column"
        sx={{
          justifyContent: 'center',
        }}
      >
        <ShoppingBasket
          data-test-id={SHOPPING_CART_BASKET_ICON_TEST_ID}
          fontSize="large"
        />
      </Stack>
    </Stack>
  );
};

export default ShoppingCart;
